import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const sideButtonStyle = {
  height: "26px",
  position: "absolute",
  right: "30px",
  top: "-52px",
  padding: "0 5px",
  marginTop: 1,
  fontSize: 14,
  zIndex: 1,
};

export const addTooltip = (component, tooltip, placement = "top") => {
  const renderTooltip = (
    <Tooltip id="tooltip-with-html">
      <div dangerouslySetInnerHTML={{ __html: tooltip }} />
    </Tooltip>
  );

  return (
    <OverlayTrigger key="top" placement={placement} overlay={renderTooltip}>
      <span>{component}</span>
    </OverlayTrigger>
  );
};
